let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hiAIo")).then(() => parcelRequire('2TsLa'));